import React from "react"
import Navbar from "../../../Common/Navbar"
import Footer from "../../../Common/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import EditManagerComp from "./Component/EditManagerComp"


const EditManager =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <EditManagerComp />
            
        </div>
        <Footer />
        </>
    )
}

export default EditManager